<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-paste"></i>
        Log Detail
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">webcastle</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Log</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              Log Info
            </div>
            <div class="mb7">
              created_at : {{model.created_at | sdate}}
            </div>
          </div>
          <hr>
          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_username" v-b-tooltip.hover>
                Attacker
              </label>
            </div>
            <div class="col-xl-4 col-md-12  d-flex align-self-center">
              <label for="ph_username" v-b-tooltip.hover v-if="this.model">{{model.remote_addr ? model.remote_addr : '-'}}</label>
            </div>
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" v-b-tooltip.hover>
                Target
              </label>
            </div>
            <div class="col-xl-4 col-md-12 d-flex align-self-center">
              <label for="ph_username" v-b-tooltip.hover v-if="this.model">{{model.target ? model.target : '-'}}</label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_seed" v-b-tooltip.hover>
                Request
              </label>
            </div>
            <div class="col-xl-4 col-md-12 d-flex align-self-center">
              <label for="ph_seed" v-b-tooltip.hover>{{model.request ? model.request : '-'}}</label>
            </div>
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_username" v-b-tooltip.hover>
                Response
              </label>
            </div>
            <div class="col-xl-4 col-md-12 align-self-center">
              <span v-if="model.is_block" class="badge badge-danger">Block</span>
              <span v-else class="badge badge-warning">Detect</span>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_seed" v-b-tooltip.hover>
                Protocol
              </label>
            </div>
            <div class="col-xl-4 col-md-12 d-flex align-self-center">
              <label for="ph_seed" v-b-tooltip.hover>{{model.protocol ? model.protocol :'-'}}</label>
            </div>
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_seed" v-b-tooltip.hover>
                Risk(Severity)
              </label>
            </div>
            <div class="col-xl-4 col-md-12 align-self-center">
              <b-badge :variant="codes.WAF_SEVERITY_TO_COLOR_EASY(model.severity,'variant')">
                {{ codes.WAF_SEVERITY_TO_DESC_EASY(model.severity, 'EN') }}
              </b-badge>
              <!-- <b-badge v-if="model.severity >= 5" variant="danger">CRITICAL</b-badge>
              <b-badge v-else-if="model.severity >= 4" variant="warning">ERROR</b-badge>
              <b-badge v-else-if="model.severity >= 3" variant="warning">WARNING</b-badge>
              <b-badge v-else-if="model.severity >= 2" variant="dark">NOTICE</b-badge>
              <b-badge v-else variant="primary">Info</b-badge> -->
              <!--<b-badge v-else variant="primary">Normal</b-badge>-->
            </div>
            <!-- // # - CRITICAL severity: Anomaly Score of 5. Mostly generated by the application attack rules (93x and 94x files).
          // # - ERROR severity: Anomaly Score of 4. Generated mostly from outbound leakage rules (95x files).
          // # - WARNING severity: Anomaly Score of 3. Generated mostly by malicious client rules (91x files).
          // # - NOTICE severity: Anomaly Score of 2. Generated mostly by the protocol rules (92x files). -->
          </div>

          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_seed" v-b-tooltip.hover>
                URI
              </label>
            </div>
            <div class="col-xl-4 col-md-12 align-self-center">
              <label for="ph_seed" v-b-tooltip.hover>{{model.uri ? model.uri : '-'}}</label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_seed" v-b-tooltip.hover>
                Rule ID
              </label>
            </div>
            <div class="col-xl-4 col-md-12 d-flex align-self-center">
              <label for="ph_seed" v-b-tooltip.hover>{{model.m_id ? model.m_id :'-'}}</label>
            </div>
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_seed" v-b-tooltip.hover>
                Rule Line
              </label>
            </div>
            <div class="col-xl-4 col-md-12 align-self-center mt-3">
              <pre for="ph_seed" v-b-tooltip.hover>{{model.m_line ? model.m_line : '-'}}</pre>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_seed" v-b-tooltip.hover>
                Rule File
              </label>
            </div>
            <div class="col-xl-4 col-md-12 align-self-center mt-3">
                <pre for="ph_seed" v-b-tooltip.hover>{{(model.m_file && model.m_file) ? (model.m_file && model.m_file) : '-'}}</pre>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_seed" v-b-tooltip.hover>
                Headers
              </label>
            </div>
            <div class="col-xl-10 col-md-12 mt-3">
              <pre for="ph_seed" v-b-tooltip.hover>{{model.headers ? model.headers : '-'}}</pre>
            </div>
          </div>
          <div class="d-flex flex-wrap align-items-center mt-5">
            <div class="title mr-auto mb7">
              Matched Information
            </div>
          </div>
          <hr>
          <div class="reg_card mt-3">
            <div class="reg_card_body">
              <div class="table-responsive">
                <table v-if="is_error == false" class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Rule ID</th>
                      <th scope="col">Message</th>
                      <!-- <th scope="col">Maturity</th> -->
                      <th scope="col">Risk</th>
                      <th scope="col">Accuracy</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in (model.message.messages || [])" :key="index">
                      <th scope="row">{{index + 1}}</th>
                      <th scope="row">{{row.details.ruleId}}</th>
                      <!-- <th scope="row">{{row.details.i18n['EN'] ? ruleI18n[row.details.ruleId] ? ruleI18n[row.details.ruleId]['ENG'] : row.message : row.message}}</th> -->
                      <th scope="row">{{row.message}}</th>
                      <!-- <th scope="row">{{row.details.maturity}}</th> -->
                      <th scope="row">
                        <b-badge :variant = "codes.WAF_SEVERITY_TO_COLOR_EASY(model.severity, 'variant')">
                          {{ codes.WAF_SEVERITY_TO_DESC_EASY(model.severity, 'EN') }}
                        </b-badge>
                      </th>
                      <th scope="row">{{row.details.accuracy}}</th>
                    </tr>
                  </tbody>
                  <tbody v-if="!model.m_id">
                    <tr>
                      <th scope="row" colspan="5">not found</th>
                    </tr>
                  </tbody>
                  <tbody v-if="error_check">
                    <tr>
                      <th scope="row" colspan="5">not found</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <b-button size="sm" class="float-right mt-3" variant="primary" @click="list">List</b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>